import { render } from "./TitleButton.vue?vue&type=template&id=43df4352&scoped=true"
import script from "./TitleButton.vue?vue&type=script&lang=js"
export * from "./TitleButton.vue?vue&type=script&lang=js"

import "./TitleButton.vue?vue&type=style&index=0&id=43df4352&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43df4352"]])

export default __exports__